import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TabsPage } from '@pages';
import { Jugador } from '@domain/jugador';
import { CargadorPcPage } from '../cargador-pc/cargador-pc';
import { AuthProvider } from '@providers/auth/auth';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';

@IonicPage()
@Component({
  selector: 'page-resultado-pc',
  templateUrl: 'resultado-pc.html',
})
export class ResultadoPcPage {

  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;

  juego: any;
  resultado: any;
  jugador: Jugador;
  equipo: Equipo;
  puntosRonda: number;
  puntosReto: number;
  preguntasCorrectas: number;
  preguntasIncorrectas: number;
  rondasGanadas: number;
  tiempo: number;

  puntosRondaOponente: number;
  puntosRetoOponente: number;
  preguntasCorrectasOponente: number;
  preguntasIncorrectasOponente: number;
  rondasGanadasOponente: number;
  tiempoOponente: number;

  readonly AUDIO_FIN = 'assets/audios/Win_reto.wav';
  private  audio = new Audio();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider
  ) {
    this.juego = navParams.get('juego');
    this.jugador = navParams.get('jugador');
    this.resultado = navParams.get('estatus');

    this.estadisticasRonda();
  }

  ionViewDidLoad() {
    if(this.resultado.estatus === -1 || this.resultado.estatus === 1) {
        this.estadisticasRondaOponente();
    }
    this.audio.src = this.AUDIO_FIN;
    this.audio.load();
    this.audio.play();
  }

  estadisticasRonda() {
    // Estadisticas Jugador sesión
    let ultimaRonda = this.getRondaJugador();
    this.puntosRonda = ultimaRonda.estadisticas.reduce( (i,j) => i + j.puntos, 0 );
    this.puntosReto = this.resultado.desafio.rondas
                        .map( r => {
                          if ( r.jugador1.jugador === this.jugador._id ) {
                            return r.jugador1.estadisticas;
                          }
                          if ( r.jugador2.jugador === this.jugador._id ) {
                            return r.jugador2.estadisticas;
                          }
                        })
                        .reduce( ( i,j ) =>  i + j.map( e => e.puntos).reduce( (n,m) => n + m ) ,0);
    this.preguntasCorrectas = ultimaRonda.totalCorrectas;
    this.preguntasIncorrectas = ultimaRonda.totalIncorrectas;
    this.rondasGanadas = this.resultado.desafio.rondas.filter( r => r.ganador === this.jugador._id).length;

    this.tiempo = ultimaRonda.estadisticas.filter( p => p.esCorrecta ).reduce( (a,b) => a + b.tiempo ,0);

    this.tiempo = Math.round(this.tiempo * 100) / 100;
  }

  estadisticasRondaOponente() {
    // Estadisticas Oponente
    let ultimaRondaOponente           = this.getRondaOponente();
    this.puntosRondaOponente          = ultimaRondaOponente.estadisticas.reduce( (i,j) => i + j.puntos, 0 );
    this.puntosRetoOponente           = this.resultado.desafio.rondas
                                          .map( r => {
                                            if ( r.jugador1.jugador === this.juego.oponente._id ) {
                                              return r.jugador1.estadisticas;
                                            }
                                            if ( r.jugador2.jugador === this.juego.oponente._id ) {
                                              return r.jugador2.estadisticas;
                                            }
                                          })
                                          .reduce( ( i,j ) =>  i + j.map( e => e.puntos).reduce( (n,m) => n + m ) ,0);
    this.preguntasCorrectasOponente   = ultimaRondaOponente.totalCorrectas;
    this.preguntasIncorrectasOponente = ultimaRondaOponente.totalIncorrectas;
    this.rondasGanadasOponente        = this.resultado.desafio.rondas.filter( r => r.ganador === this.juego.oponente._id).length;

    this.tiempoOponente = ultimaRondaOponente.estadisticas.filter( p => p.esCorrecta ).reduce( (a,b) => a + b.tiempo ,0);

    this.tiempoOponente = Math.round(this.tiempoOponente * 100) / 100;
  }

  getRondaJugador() {
    let ronda = this.resultado.desafio.rondas[this.resultado.desafio.rondas.length - 1];

    if ( ronda.jugador1.jugador == this.jugador._id ) {
      return ronda.jugador1;
    }

    if ( ronda.jugador2.jugador == this.jugador._id ) {
      return ronda.jugador2;
    }
  }

  getRondaOponente() {
    let ronda = this.resultado.desafio.rondas[this.resultado.desafio.rondas.length - 1];

    if ( ronda.jugador1.jugador == this.juego.oponente._id ) {
      return ronda.jugador1;
    }

    if ( ronda.jugador2.jugador == this.juego.oponente._id ) {
      return ronda.jugador2;
    }
  }

  terminarReto() {
    if ( this.resultado.siguienteRonda ) {
      this.authProvider.getSession()
        .then( jugador => {
          this.jugador = jugador;
          return this.authProvider.getEquipo();
        })
        .then( equipo => {
          this.equipo = equipo;
          this.navCtrl.setRoot(CargadorPcPage, {
            jugador: this.jugador,
            equipo: this.equipo,
            juego:  this.resultado.siguienteRonda
          });
        });
    } else {
      this.navCtrl.setRoot(TabsPage, {
        active: 0
      });
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/resultado-pc/resultado-pc.ts